// chart-race 编辑器：时间线完整编辑（帧 + 帧内对比项 label/value/color）。
// 复用通用控件库 components/editor-controls（Field/TextInput/ColorField/Repeater...）。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { ChartRaceData } from './types'
import {
  Field,
  TextInput,
  NumberInput,
  ColorField,
  Repeater,
  RemoveButton,
} from '../../components/editor-controls'

export function ChartRaceEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as ChartRaceData
  const tl = d.timeline || []
  const newFrameItems = () => {
    const last = tl[tl.length - 1]
    return last && last.items ? last.items.map((x) => ({ label: x.label, value: 0, color: x.color })) : []
  }
  return (
    <>
      <Field label={t('editor.title')}>
        <TextInput value={d.title ?? ''} onChange={(v) => update((dd) => { dd.title = v })} />
      </Field>
      <Field label={t('editor.valueFormat')}>
        <div style={{ display: 'flex', gap: 6 }}>
          <TextInput value={d.valuePrefix ?? ''} placeholder={t('editor.valuePrefixPh')} onChange={(v) => update((dd) => { dd.valuePrefix = v })} />
          <TextInput value={d.valueSuffix ?? ''} placeholder={t('editor.valueSuffixPh')} onChange={(v) => update((dd) => { dd.valueSuffix = v })} />
          <NumberInput value={d.valueDigits ?? 2} onChange={(v) => update((dd) => { dd.valueDigits = v })} min={0} max={4} style={{ width: 60 }} />
        </div>
      </Field>
      <Field label={t('editor.timelineCount', { count: tl.length })} hint={t('editor.timelineHint')}>
        {tl.map((frame, fi) => (
          <div className="editable-item col tl-frame" key={fi}>
            <div className="editable-item tl-frame-head">
              <span className="ei-rank">{fi + 1}</span>
              <NumberInput
                value={frame.year}
                onChange={(v) => update((dd) => { dd.timeline[fi].year = v })}
                style={{ width: 120 }}
              />
              <RemoveButton onRemove={() => update((dd) => { dd.timeline.splice(fi, 1) })} label={t('editor.deleteFrame')} />
            </div>
            {(frame.items || []).map((it, ii) => (
              <div className="editable-item col tl-item" key={ii}>
                <div className="editable-item">
                  <TextInput
                    value={it.label}
                    onChange={(v) => update((dd) => { dd.timeline[fi].items[ii].label = v })}
                    placeholder={t('editor.namePh')}
                    style={{ flex: 2 }}
                  />
                  <NumberInput
                    value={it.value}
                    onChange={(v) => update((dd) => { dd.timeline[fi].items[ii].value = v })}
                    placeholder={t('editor.valuePh')}
                    style={{ flex: 1 }}
                  />
                  <RemoveButton onRemove={() => update((dd) => { dd.timeline[fi].items.splice(ii, 1) })} label={t('editor.deleteItem')} />
                </div>
                <ColorField
                  value={it.color}
                  onChange={(c) => update((dd) => { dd.timeline[fi].items[ii].color = c })}
                />
              </div>
            ))}
            <Repeater
              addLabel={t('editor.compareItem')}
              onAdd={() =>
                update((dd) => {
                  dd.timeline[fi].items.push({ label: '', value: 0, color: '#6366f1' })
                })
              }
            />
          </div>
        ))}
        <Repeater
          addLabel={t('editor.frame')}
          onAdd={() =>
            update((dd) => {
              dd.timeline.push({ year: (tl[tl.length - 1]?.year ?? 2020) + 1, items: newFrameItems() })
            })
          }
        />
      </Field>
    </>
  )
}
